export default __webpack_public_path__ + "static/media/topping_yellowcat.b5932232.jpg";